/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import CustomLink from 'components/shared/CustomLink'

const ButtonShell = ({ newPage, isAnchor, to, children, className, target }) => (
  !isAnchor ? (
    <CustomLink newPage={newPage} to={to} className={className} target={target} >{children}</CustomLink>
  ) : (
    <a href={to} className={className}>{children}</a>
  )
)

export default ButtonShell